export default "__VITE_ASSET__BZgNgHtO__"